export function renderPanelBaseline(panelElem, panelLayout, xPadding) {

	// Offset the y coordinates by half a pixel - D3 offsets axis ticks by the same amount.
	panelElem.append('line')
		.attr('class', 'hw_panel_graph_panel_baseline')
		.attr('x1', panelLayout.x - xPadding)
		.attr('x2', panelLayout.x + panelLayout.width + xPadding)
		.attr('y1', panelLayout.y + panelLayout.height + 0.5)
		.attr('y2', panelLayout.y + panelLayout.height + 0.5);

}


// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-panel-baseline.js